/** FP Uline list view — mobile default list, ATC, Type In Size */
(function () {
  var MQ = window.matchMedia('(min-width: 750px)');

  function money(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function snap(n, min, step) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < min) return min;
    if (step > 1) {
      var off = (n - min) % step;
      if (off !== 0) n = n - off;
      if (n < min) n = min;
    }
    return n;
  }

  function applyMobileListDefault() {
    /* FP_MOBILE_LIST_DEFAULT_V2 */
    if (MQ.matches) return;
    var grid = document.querySelector('.product-grid');
    if (!grid) return;
    var userChose = sessionStorage.getItem('fp-mobile-view-chosen') === '1';
    var stored = sessionStorage.getItem('product-grid-view-mobile');
    var value =
      userChose && (stored === 'default' || stored === 'mobile-single') ? stored : 'mobile-single';
    grid.setAttribute('product-grid-view', value);
    var options = document.querySelectorAll('input[type="radio"][name="grid-mobile"]');
    for (var i = 0; i < options.length; i++) {
      options[i].checked = options[i].value === value;
    }
  }

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  async function addToCart(variantId, qty) {
    var res = await fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty) }] }),
    });
    if (!res.ok) {
      var err = await res.json().catch(function () { return {}; });
      throw new Error((err && err.description) || 'Add failed');
    }
    return res.json();
  }

  function refreshCartUI() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:update'));
    } catch (e) {}
    var drawer = document.querySelector('cart-drawer-component, cart-drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') drawer.open();
      else if (typeof drawer.show === 'function') drawer.show();
      else drawer.removeAttribute('hidden');
    }
  }

  function bindListActions(root) {
    root = root || document;
    var rows = root.querySelectorAll('[data-fp-list-actions]');
    for (var i = 0; i < rows.length; i++) {
      (function (row) {
        if (row.getAttribute('data-fp-bound') === '1') return;
        row.setAttribute('data-fp-bound', '1');
        var qty = row.querySelector('.fp-list-qty');
        var btn = row.querySelector('[data-fp-list-add]');
        var min = parseInt(qty && qty.min, 10) || 1;
        var step = parseInt(qty && qty.step, 10) || 1;
        if (qty) {
          qty.addEventListener('change', function () {
            qty.value = String(snap(qty.value, min, step));
          });
          qty.addEventListener('blur', function () {
            qty.value = String(snap(qty.value, min, step));
          });
          // Stop card link navigation
          qty.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); });
          qty.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
        }
        if (btn) {
          btn.addEventListener('click', async function (e) {
            e.preventDefault();
            e.stopPropagation();
            var vid = row.getAttribute('data-variant-id');
            if (!vid || btn.disabled) return;
            var q = snap(qty ? qty.value : min, min, step);
            if (qty) qty.value = String(q);
            var prev = btn.textContent;
            btn.disabled = true;
            btn.textContent = '…';
            try {
              await addToCart(vid, q);
              btn.textContent = 'Added';
              refreshCartUI();
              setTimeout(function () { btn.textContent = prev || 'Add'; btn.disabled = false; }, 900);
            } catch (err) {
              btn.textContent = 'Err';
              setTimeout(function () { btn.textContent = prev || 'Add'; btn.disabled = false; }, 1200);
            }
          });
          btn.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
        }
        row.addEventListener('click', function (e) { e.stopPropagation(); });
      })(rows[i]);
    }
  }

  function parseDim(v) {
    if (v == null || v === '') return null;
    var n = parseFloat(String(v).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  }

  function titleDims(title) {
    var m = String(title || '').match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    if (!m) return null;
    return { l: parseFloat(m[1]), w: parseFloat(m[2]), h: parseFloat(m[3]) };
  }

  function bindTypeInSize() {
    var bar = document.querySelector('[data-fp-type-in-size]');
    if (!bar || bar.getAttribute('data-fp-bound') === '1') return;
    bar.setAttribute('data-fp-bound', '1');
    var btn = bar.querySelector('[data-fp-size-search]');
    function run() {
      var L = parseDim(bar.querySelector('[data-fp-size-l]') && bar.querySelector('[data-fp-size-l]').value);
      var W = parseDim(bar.querySelector('[data-fp-size-w]') && bar.querySelector('[data-fp-size-w]').value);
      var H = parseDim(bar.querySelector('[data-fp-size-h]') && bar.querySelector('[data-fp-size-h]').value);
      var items = document.querySelectorAll('.product-grid__item');
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var titleEl = item.querySelector('.text-block, .product-card .rte, [role="heading"]');
        var title = (titleEl && titleEl.textContent) || '';
        var d = titleDims(title);
        var show = true;
        if (L != null || W != null || H != null) {
          show = !!d;
          if (show && L != null && d.l !== L) show = false;
          if (show && W != null && d.w !== W) show = false;
          if (show && H != null && d.h !== H) show = false;
        }
        item.style.display = show ? '' : 'none';
      }
    }
    if (btn) btn.addEventListener('click', run);
    bar.querySelectorAll('input').forEach(function (inp) {
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          run();
        }
      });
    });
  }

  function setup() {
    applyMobileListDefault();
    bindListActions(document);
    bindTypeInSize();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
  // Infinite scroll / morph may add cards
  var obs = new MutationObserver(function () { bindListActions(document); });
  if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  else document.addEventListener('DOMContentLoaded', function () {
    obs.observe(document.body, { childList: true, subtree: true });
  });
})();
